import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useExtraServicesStore = defineStore('storeextraservices', () => {
  // Store Models
  const xero                        = ref(false)
  const bas                         = ref(false)
  const tax_return                  = ref(false)
  const payroll                     = ref(false)
  const bookkeeping                 = ref(false)
  const superannuation              = ref(false)
  const tax_accountant_consultation = ref(false)
  const wants_membership_trial      = ref(false)
  const membership_upsell_variant   = ref(null)

  const update = (order) => {
    xero.value                        = !!order.extra_services?.find(e => e.key === 'xero')
    bas.value                         = !!order.extra_services?.find(e => e.key === 'bas')
    tax_return.value                  = !!order.extra_services?.find(e => e.key === 'tax_return')
    payroll.value                     = !!order.extra_services?.find(e => e.key === 'payroll')
    bookkeeping.value                 = !!order.extra_services?.find(e => e.key === 'bookkeeping')
    superannuation.value              = !!order.extra_services?.find(e => e.key === 'superannuation')
    tax_accountant_consultation.value = !!order.extra_services?.find(e => e.key === 'tax_accountant_consultation')
  }

  const enableXeroOptionInPage = () => {
    resetData();
    xero.value = true;
  };

  const enableBasOptionInPage = () => {
      resetData();
      bas.value = true;
  };

  const enableTaxReturnOptionInPage = () => {
      resetData();
      tax_return.value = true;
  };

  const enablePayrollOptionInPage = () => {
      resetData();
      payroll.value = true;
  };

  const enableBookkeepingOptionInPage = () => {
      resetData();
      bookkeeping.value = true;
  };

  const enableSuperannuationOptionInPage = () => {
      resetData();
      superannuation.value = true;
  };

  const enableTaxAccountantConsultationOptionInPage = () => {
      resetData();
      tax_accountant_consultation.value = true;
  };

  const resetData = () => {
    xero.value = false;
    bas.value = false;
    tax_return.value = false;
    payroll.value = false;
    bookkeeping.value = false;
    superannuation.value = false;
    tax_accountant_consultation.value = false;
    wants_membership_trial.value = false;
};

  return {
    xero,
    bas,
    tax_return,
    payroll,
    bookkeeping,
    superannuation,
    tax_accountant_consultation,
    wants_membership_trial,
    membership_upsell_variant,
    enableXeroOptionInPage,
    enableBasOptionInPage,
    enableTaxReturnOptionInPage,
    enablePayrollOptionInPage,
    enableBookkeepingOptionInPage,
    enableSuperannuationOptionInPage,
    enableTaxAccountantConsultationOptionInPage,
    resetData,
    update,
  }
}, { persist:true })
